import React from "react";
import { Outlet } from "react-router-dom";

import { Box } from "@mui/material";

import { AlertProvider } from "./AlertProvider";

export const FullPageProvider = () => {
  return (
    <Box
      sx={{
        display: "flex",
        marginLeft: "auto",
        marginRight: "auto",
        // backgroundColor: "#F5F5F5",
        maxWidth: "100%",
      }}
    >
      <AlertProvider />
      <Outlet />
    </Box>
  );
};
